<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        body: [
          `A shared ID happens when two different people are assigned the same identifier. 
          If an identifier is shared, one of the records should be split to a new master record 
          and identifier. History records will need to be assigned to the corresponding master 
          record.`,
          `Search: Be sure to select at least one name field to generate quality results. Click Search.`,
          `Search Results: Click the drill through action icon to see the details for the selected row in the search results.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
